module.exports = __webpack_public_path__ + "img/section4Logo3.62368916.webp";